import { diffDate } from "utils/date";
import { validateEmail } from "utils/validate";

export function validateFullName(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validateGender(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validatePhoneNumber(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validateAadharNumber(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validateDate(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }

    const nowDate = new Date(value);
    const maxDate = new Date();
    const minDate = new Date("1000-01-01");

    if (diffDate(nowDate, minDate) < 0) {
        return "Min date is 1000-01-01";
    }

    if (diffDate(maxDate, nowDate) < 0) {
        return "Max date is now";
    }

    return null;
}

export function validateCountry(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validateState(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validatePincode(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validateEmailInput(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }

    if (!validateEmail(value)) {
        return "Invalid email";
    }
    return null;
}